/* eslint-disable import/order */
import React, { useContext } from 'react';
import { func } from 'prop-types';
import { useMediaQuery } from '@mui/material';

// Utils
import { DRAWER_TYPES } from 'utils/constants';
import { DrawerContext } from 'common/drawer/DrawerContext';

// Components
import CreatePtoWizard from '../../create-wizard/CreateWizard.connector';
import DesktopMenuItems from './DesktopMenuItems';
import MobileMenuItems from './MobileMenuItems';

const SearchTopBar = props => {
  const { fetchCSVReport, toggleDrawer, resetCreatePto } = props;
  const lgUp = useMediaQuery(theme => theme.breakpoints.up('lg'));

  const { setDrawerComponentProps } = useContext(DrawerContext);

  const createNewPto = () =>
    setDrawerComponentProps({
      Component: compProps => <CreatePtoWizard isCopyToNew={false} {...compProps} />,
      resetWizard: resetCreatePto,
      type: DRAWER_TYPES.createNewPto,
    });

  return lgUp ? (
    <DesktopMenuItems createNewPto={createNewPto} fetchCSVReport={fetchCSVReport} />
  ) : (
    <MobileMenuItems createNewPto={createNewPto} toggleDrawer={toggleDrawer} />
  );
};

SearchTopBar.propTypes = {
  fetchCSVReport: func.isRequired,
  resetCreatePto: func.isRequired,
  toggleDrawer: func.isRequired,
};

export default SearchTopBar;
